/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Onboarding_V1_Pick_Select_PortfolioInputs */

const en_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.title}`)
};

const de_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} auswählen`)
};

const pt_br2_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecionar ${i?.title}`)
};

const tr_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} portföyünü seç`)
};

const zh_cn2_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择${i?.title}`)
};

const zh_hk2_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選擇${i?.title}`)
};

const ko_kr2_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 선택`)
};

const ru_ru2_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выбрать ${i?.title}`)
};

const es_419_onboarding_v1_pick_select_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Select_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Select {title}" |
*
* @param {Onboarding_V1_Pick_Select_PortfolioInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_select_portfolio = /** @type {((inputs: Onboarding_V1_Pick_Select_PortfolioInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_Select_PortfolioInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "de") return de_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_select_portfolio(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_select_portfolio(inputs)
	return es_419_onboarding_v1_pick_select_portfolio(inputs)
});